module.exports = __webpack_public_path__ + "static/media/20.64b0c880.jpg";